import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  COMMENT_TASK,
} from 'constants/formFields';
import { dataTaskCommentSchema } from 'utils/validators';

import type { TDataTaskCommentSchema } from 'utils/validators';

const useTaskInfoFields = () => {
  const {
    handleSubmit,
    control,
    formState: { isDirty, isLoading, errors },
    getValues,
    setError,
    setValue,
    watch,
    reset,
  } = useForm<TDataTaskCommentSchema>({
    resolver: yupResolver(dataTaskCommentSchema),
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {
      [COMMENT_TASK]: '',
    },
  });

  return {
    control,
    handleSubmit,
    isDirty,
    isLoading,
    getValues,
    setError,
    setValue,
    watch,
    reset,
    errors,
  };
};

export default useTaskInfoFields;
